var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkMobileDevice())?_c('list-banner-mobile',{attrs:{"banners":_vm.banners,"fetched":_vm.bannersFetched}}):_c('list-banner',{attrs:{"banners":_vm.banners,"time-change-banner":_vm.timeChangeBanner}})}
var staticRenderFns = []

export { render, staticRenderFns }